<template>
  <div>
    <!-- 职位取消/改报提示 -->
    <div v-if="projectDetail.project_info.exami_type === '公务员录聘'" class="bkxx-wrap">
      
      <div v-if="isCancelled || applyStatus == -3" class="flex-x-center" style="margin-bottom: 20px;">
        <div style="width: 100%; background: #fff3cd; border: 1px solid #ffc107; border-radius: 5px; padding: 15px 20px; color: #856404;">
          <i class="el-icon-warning" style="margin-right: 5px;"></i>
          <strong v-if="applyStatus == -3">您的报名审核已被退回<span v-if="applyMessage">：{{ applyMessage }}</span>。请修改您的报名信息或改报其他职位。</strong>
          <strong v-else>您报考的职位【{{ oldPosition ? oldPosition.title : '' }}】已被取消。</strong>
          <span v-if="changeCount >= changeLimit" style="color: #f56c6c; font-weight: bold;">您已达到最大改报次数限制（{{changeLimit}}次），无法继续改报。</span>
          <span v-else-if="windowOpen">请在改报窗口期内重新选择职位。改报新职位将触发资格重审，且需要重新缴纳新科目的费用。当前已改报 {{changeCount}} / {{changeLimit}} 次。</span>
          <span v-else>{{ windowMsg }}</span>
        </div>
      </div>

      <!-- 选择报考职位卡片 -->
      <div class="bkxx-card" v-if="isChangeMode">
        <div class="card-header">
          <span class="card-title">请选择新报考职位</span>
          <span class="card-tip">温馨提示：输入职位（岗位）代码后，系统自动查询对应职位信息</span>
        </div>
        <div class="card-body">
          <el-form label-width="120px" size="small">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="请选择考试地区">
                  <el-cascader v-model="selectOne" :options="area_one_list" :props="props" style="width:100%"></el-cascader>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="请选择报名地市">
                  <el-cascader v-model="selectTwo" :options="area_two_list" :props="props" style="width:100%"></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="职位代码">
                  <el-input v-model="pisitionId" placeholder="请输入职位代码" @keyup.enter.native="registerPosition">
                    <el-button slot="append" type="primary" @click="registerPosition">查询</el-button>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20" v-if="positionModel">
              <el-col :span="12">
                <el-form-item label="单位名称">
                  <el-input :value="positionModel.company" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职位名称">
                  <el-input :value="positionModel.title" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            
            <!-- 条件不满足提示 -->
            <div v-if="unmetConditions.length > 0" style="margin-top: 10px; color: #f56c6c; font-size: 13px;">
              <div v-for="(item, idx) in unmetConditions" :key="idx">
                <i class="el-icon-error"></i> {{ item.field_title }}：要求 {{ item.operator }} {{ item.required_value }}，您的实际值为 {{ item.actual_value || '空' }}
              </div>
            </div>
          </el-form>
        </div>
      </div>
      
      <!-- 如果不是改报模式，显示原职位只读卡片 -->
      <div class="bkxx-card" v-else>
        <div class="card-header">
          <span class="card-title">当前报考职位</span>
          <span class="card-tip">（已报名成功，不可更改）</span>
        </div>
        <div class="card-body">
           <el-form label-width="120px" size="small" v-if="oldPosition">
             <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="单位名称">
                  <el-input :value="oldPosition.company" disabled></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="职位名称">
                  <el-input :value="oldPosition.title" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="职位代码">
                  <el-input :value="oldPosition.code" disabled></el-input>
                </el-form-item>
              </el-col>
            </el-row>
           </el-form>
        </div>
      </div>

      <!-- 职位条件 -->
      <div class="bkxx-card" v-if="displayPosition">
        <div class="card-header"><span class="card-title">职位条件</span><span class="card-tip">（详细内容阅读招考公告）</span></div>
        <div class="card-body">
          <el-descriptions :column="3" border size="small">
            <el-descriptions-item label="岗位咨询电话">{{ displayPosition.section_tel }}</el-descriptions-item>
            <el-descriptions-item label="招考人数">{{ displayPosition.num }}人</el-descriptions-item>
            <el-descriptions-item label="招考比例">{{ displayPosition.percent }}</el-descriptions-item>
          </el-descriptions>
          <el-table :data="conditionList" style="width:100%;margin-top:16px;" size="small" border v-if="conditionList.length">
            <el-table-column prop="field_title" label="指标"></el-table-column>
            <el-table-column label="要求" width="120">
              <template #default="scope">{{ operatorText(scope.row.operator) }}</template>
            </el-table-column>
            <el-table-column label="指标值">
              <template #default="scope">{{ scope.row.value_text || scope.row.value }}</template>
            </el-table-column>
            <el-table-column prop="label" label="说明"></el-table-column>
          </el-table>
          <div style="margin-top:12px;font-size:14px;color:#606266;" v-if="displayPosition.other">
            <span>其他条件：</span><span style="color:#303133;">{{ displayPosition.other }}</span>
          </div>
        </div>
      </div>

      <!-- 考试科目 -->
      <div class="bkxx-card" v-if="displayPosition">
        <div class="card-header"><span class="card-title">考试科目</span></div>
        <div class="card-body">
          <el-table :data="displayTableDetail" style="width:100%" size="small" border>
            <el-table-column width="60" align="center" label="选择">
              <template #default="scope">
                <el-checkbox :disabled="scope.row.disabled" v-model="displayTableDetail[scope.$index].check"></el-checkbox>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="科目"></el-table-column>
            <el-table-column prop="money" label="费用" width="120"></el-table-column>
          </el-table>
        </div>
      </div>

      <div v-if="isChangeMode && !positionModel" class="bkxx-card"><div class="card-body empty-tip">请先输入新职位代码并查询</div></div>
      
      <div class="bkxx-submit" v-if="isChangeMode">
        <el-button type="primary" size="medium" @click="checkBkxx()">提交改报</el-button>
      </div>
      <div class="bkxx-submit" v-else>
        <el-button type="primary" size="medium" @click="$parent.next()">下一步</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useMainStore } from "@/store/piniaStore";
import { reqPositionChangeStatus, reqValidatePosition, reqSubmitPositionChange, reqProjectDetail } from "@/api";

export default {
  data() {
    return {
      props: { multiple: false },
      selectOne: "",
      selectTwo: "",
      pisitionId: "",
      positionModel: null,
      tableDetail: [],
      major_id: "",
      grade_id: "",

      // 改报相关状态
      isCancelled: false,
      windowOpen: false,
      windowMsg: "",
      oldPosition: null,
      isChangeMode: false,
      unmetConditions: [],
      changeCount: 0,
      changeLimit: 1,
      applyStatus: 0,
      applyMessage: "",
    };
  },
  props: {
    process_index: { type: Number, default: 0 },
    process: { type: Object, default() { return {}; } },
  },
  computed: {
    ...mapState(useMainStore, { projectDetail: "getProjectDetail" }),
    
    // For read-only vs editable display
    displayPosition() {
        return this.isChangeMode ? this.positionModel : this.oldPosition;
    },
    displayTableDetail() {
        return this.isChangeMode ? this.tableDetail : (this.oldPosition ? this.oldPosition.subject_list : []);
    },

    area_one_list() {
      if (this.projectDetail.project_info.exami_type == "公务员录聘" && this.process.content && this.process.content.area_list) {
        return this.process.content.area_list.area_list.map((i) => ({ value: i.id, label: i.city }));
      }
      return [];
    },
    area_two_list() {
      if (this.projectDetail.project_info.exami_type == "公务员录聘" && this.process.content && this.process.content.area_list) {
        let arr = [];
        let curAreaId = Array.isArray(this.selectOne) ? this.selectOne[0] : this.selectOne;
        this.process.content.area_list.area_list.forEach((item) => {
          if (curAreaId == item.id) {
            let pt = item.point || item.Point;
            if (pt) {
              if (Array.isArray(pt)) {
                arr = pt.map((p) => ({ value: p.id, label: p.city }));
              } else {
                arr = [{ value: pt.id, label: pt.city }];
              }
            }
          }
        });
        return arr;
      }
      return [];
    },
    conditionList() {
      if (!this.displayPosition) return [];
      var raw = this.displayPosition.condition_json || this.displayPosition.fieldlist_json;
      if (!raw) return [];
      try {
        var list = typeof raw === "string" ? JSON.parse(raw) : raw;
        return Array.isArray(list) ? list : [];
      } catch (e) { return []; }
    },
  },
  methods: {
    operatorText(op) {
      return { '=': '等于', '!=': '不等于', '>': '大于', '<': '小于', '>=': '大于等于', '<=': '小于等于' }[op] || op;
    },
    registerPosition() {
      if (!this.isChangeMode) return;
      reqValidatePosition({
        position_code: this.pisitionId,
        project_id: this.$parent.projectDetail.project_info.id,
      }).then((res) => {
        if (res.data.code === 1) {
          var data = res.data.data;
          this.positionModel = data.position;
          this.unmetConditions = data.unmet_conditions || [];
          this.tableDetail = data.subject_list.map((item) => {
            return {
              check: item.is_must == 1 ? true : false,
              disabled: item.is_must == 1 ? true : false,
              ...item,
            };
          });
          this.grade_id = data.position.grade_id;
          this.major_id = data.position.major_id;
          if (!data.conditions_met) {
            this.$message.warning("您不满足该职位的部分条件，请查看详情");
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    checkBkxx() {
      if (!this.isChangeMode) return;
      if (this.selectOne == "") return this.$message.error("请选择报考地区");
      if (this.selectTwo == "") return this.$message.error("请选择报考地市");
      if (this.pisitionId == "") return this.$message.error("请输入新职位代码");
      if (this.pisitionId != "" && this.grade_id == "") return this.$message.error("请确认职位代码是否正确，并点击查询");
      if (this.unmetConditions.length > 0) return this.$message.error("您不满足目标职位条件，无法改报");

      let checkIds = [];
      this.tableDetail.forEach((item) => {
        if (item.check) checkIds.push(item.id);
      });
      let processList = this.$parent.projectDetail.process || [];
      let kqgbIndex = processList.findIndex(p => p.name === 'kqgb');

      var data = {
        area_id: this.selectOne[0],
        point_id: this.selectTwo[0],
        subject_ids: checkIds,
        project_id: this.$parent.projectDetail.project_info.id,
        position_id: this.positionModel.id,
        current_step: kqgbIndex !== -1 ? kqgbIndex : 0,
      };

      reqSubmitPositionChange(data).then((res) => {
        if (res.data.code === 1) {
          this.$message.success("改报提交成功，即将返回资格审查...");
          setTimeout(() => {
             let processList = this.$parent.projectDetail.process || [];
             let zgscIndex = processList.findIndex(p => p.name === 'zgsc');
             if(zgscIndex !== -1) {
                localStorage.setItem('active', zgscIndex);
                localStorage.setItem('currentStepName', 'zgsc');
                this.$parent.step_name = 'zgsc';
             }
             this.$parent.reload();
          }, 800);
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    ...mapActions(useMainStore, { changeProject: "updateProjectDetail" }),
  },
  mounted() {
    // 检查改报状态
    var projectId = this.$parent.projectDetail.project_info.id;
    reqPositionChangeStatus({ project_id: projectId }).then((res) => {
      if (res.data.code === 1) {
        var data = res.data.data;
        this.isCancelled = data.is_cancelled;
        this.windowOpen = data.window_open;
        this.windowMsg = data.window_msg;
        this.oldPosition = data.old_position;
        this.changeCount = data.change_count || 0;
        this.changeLimit = data.change_limit || 1;
        this.applyStatus = data.apply_status || 0;
        this.applyMessage = data.apply_message || "";
        // 如果职位已取消且窗口开放，或者报名被退回，且次数未满，进入改报模式
        if ((data.is_cancelled || this.applyStatus == -3) && data.window_open && this.changeCount < this.changeLimit) {
          this.isChangeMode = true;
        }
      }
    });
  },
};
</script>

<style scoped>
.bkxx-wrap { max-width: 900px; margin: 20px auto; }
.bkxx-card { background: #fff; border: 1px solid #e8e8e8; border-radius: 6px; margin-bottom: 16px; }
.card-header { padding: 12px 20px; border-bottom: 1px solid #e8e8e8; display: flex; align-items: center; }
.card-title { font-size: 15px; font-weight: 600; color: #303133; }
.card-tip { font-size: 13px; color: #909399; margin-left: 12px; }
.card-body { padding: 20px; }
.empty-tip { text-align: center; color: #999; padding: 40px 0; }
.bkxx-submit { text-align: center; padding: 20px 0; }
</style>
